var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"route-container",attrs:{"id":"fingerprint"}},[_c('p',[_vm._v("Your fingerprint:")]),_c('p',[_c('b',[_vm._v(_vm._s(_vm.fingerprint))])])])}
var staticRenderFns = []

export { render, staticRenderFns }